import axiosInstance from './axiosInstance'; // ✅ default import

export type Faq = {
  id: number;
  question: 'string';
  answer: 'string';
  createdAt: string;
  updatedAt: string;
};
// 공지사항 전체 조회
export const fetchFaqs = async (): Promise<Faq[]> => {
  const res = await axiosInstance.get<Faq[]>('/api/allbadeum/v1/faq');
  return res.data;
};

// ✅ 공지사항 단건 조회
export const fetchFaqsById = async (id: number): Promise<Faq> => {
  const res = await axiosInstance.get<Faq>(`/api/allbadeum/v1/faq/${id}`);
  return res.data;
};
